<template>
<div>
    <div class="form-group slider-group">
            <label>{{lng.duration}}
                <select v-model="dtype" @change="setTypeDuration">
                    <option value="month">month</option>
                    <option value="week">week</option>
                </select>
            </label>

            <div class="slider-group-box">

            <div class="slider-input-box">
               <input type="text" :value="duration.value[0]"
                 ref="dfrom" class="slider-group-box__input"
               >
                <span> - </span>
                 <input type="text" :value="duration.value[1]"
                    ref="dto" class="slider-group-box__input"
              >
              </div>
              <button @click.prevent="handlerSend" class="btn btn-slider">Set</button>

            </div>
            <vue-slider ref="sliderEl"  @drag-end="stopDrag" v-bind="duration" v-model="duration.value"></vue-slider>
    </div>
    <div class="form-group">
        <input v-model="dataRequest.permanent"
               @change="sendRequest"
            type="checkbox" id="checkbox-id" />
        <label for="checkbox-id" class="checkbox">Permanent contract</label>
    </div>
</div>
</template>

<script>
import vueSlider from 'vue-slider-component';
import {mapActions, mapGetters} from 'vuex';

export default {
    components: {
        vueSlider
   },
   data(){
      return {
        duration: {
            value: [1,12],
            min: 1,
            max: 12,
            interval: 1,
            dotSize: 10,
            tooltip: 'none'

        },
        dtype: 'month'
      }
   },
   created(){
      let el = this.$refs.yrank;


   },
   computed: {
        ...mapGetters([
            'lng',
            'dataRequest',

        ])
   },
   methods: {
        ...mapActions([
            'prepareRequest',
            'sendRequest'
        ]),

        stopDrag(e){
         this.prepareRequest({key: 'duration', val: 1});
         this.prepareRequest({key: 'dfrom', val: e.value[0] });
         this.prepareRequest({key: 'dto', val: e.value[1] });
             this.sendRequest();
         },
         setTypeDuration(){
             this.prepareRequest({key: 'duration', val: 1});
             this.prepareRequest({key: 'dtype', val: this.dtype});
             this.sendRequest();
         },

         handlerSend(){
            const dfrom = this.$refs.dfrom;
            const fromVal = dfrom.value
            const dto = this.$refs.dto;
            const toVal = dto.value

            let val = this.duration.value;

            if(parseInt(fromVal) >= parseInt(toVal)) {
                this.duration.value = [this.duration.min, this.duration.max];
                dfrom.value = this.duration.min;
                dto.value = this.duration.max;
            }
            if(parseInt(toVal) > parseInt(val[1])) {
                 dto.value = this.duration.max
            }
            if(parseInt(fromVal) < 0 ) {
                 dfrom.value = 1;
             }
             this.duration.value = [dfrom.value, dto.value];

             this.prepareRequest({key: 'duration', val: 1});
             this.prepareRequest({key: 'dfrom', val: this.duration.value[0]});
             this.prepareRequest({key: 'dto', val: this.duration.value[1] });
             this.sendRequest();



         }
   }
}
</script>

<style>

.slider-group {
    margin-bottom: 12px;
    overflow:hidden;
}

.slider-group-box {
    display: flex;
    align-items: flex-start;
}

.slider-input-box {
    display:flex;
    width: 60%;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}
.slider-group-box button.btn-slider {
    width: auto;
    padding: 5px 8px;
    margin-left: auto;
    line-height: 1;
    height: auto;
    border-radius: 6px;
    background-color: rgb(5, 151, 205);

}

.slider-group-box__input {
    width: 50px;

}
.slider-group-box__input_salary {
    width: 70px;
}

</style>


// WEBPACK FOOTER //
// Duration.vue?516ccdd8